import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getIsPoliciesLoading, getPolicies as getPoliciesSelector } from '@verzekeringapp-mono/shared/src/state/selectors/policies'
import usePolicies from '@verzekeringapp-mono/shared/src/hooks/use_policies'
import PolicyCard from './components/PolicyCard'
import useProducts from '@verzekeringapp-mono/shared/src/hooks/use_product'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getProductIsLoading } from '@verzekeringapp-mono/shared/src/state/selectors/products'
import { getProducts as getProductsSelector } from '@verzekeringapp-mono/shared/src/state/selectors/products'
import LoadingIndicator from '~/components/LoadingIndicator'
import { withinLossWindow } from '@verzekeringapp-mono/shared/src/utils/policy_utils'

const ClaimDamage = () => {
  const { getPolicies } = usePolicies()

  const policies = useSelector(getPoliciesSelector)
  const { getProducts } = useProducts()
  const products = useAppSelector(getProductsSelector)
  const isProductsLoading = useAppSelector(getProductIsLoading())
  const isPoliciesLoading = useAppSelector(getIsPoliciesLoading)

  const filteredPolicies = useMemo(() => policies.filter(
    (policy) => policy.isAllowedToReportClaim && withinLossWindow(policy)
  ), [policies])

  useEffect(() => {
    getPolicies()
    getProducts()
  }, [])

  return (
    <ScreenWrapper hasPadding={false}>
      <div className='m-auto rounded bg-surface-page p-8 sm:w-9/12 md:10/12'>
        <div className='flex flex-col items-center'>
          <div className='mb-4 text-6xl text-icon-secondary'>
            <FontAwesomeIcon
              icon='fragile'
              size='xl'
            />
          </div>

          <h1 className='mb-2 text-center text-3xl text-text-primary'>Schade melden</h1>

          <p className='mb-6 text-center text-text-primary'>
            Oei, wat vervelend! Je hebt schade. We willen je hier graag
            bij helpen. Om je te helpen moeten we weten op welke
            polis je de schade wilt melden.
          </p>
        </div>

        {
          (isPoliciesLoading || isProductsLoading) && (
            <div className='flex justify-center my-4'>
              <LoadingIndicator />
            </div>
          )
        }

        {products &&
        filteredPolicies.map(policy => (
          <PolicyCard
            key={policy.id}
            {...policy}
          />
        ))}
      </div>
    </ScreenWrapper>
  )
}

export default ClaimDamage
